  const dataSelectDay = [
    {
      value: "120",
      label: "ยอดน้อยกว่า 20% ขาดติดต่อ 120 วัน", 
    },
    {
      value: "180",
      label: "เกรด D ขึ้นไป ยอดมากกว่า 20% ขาดติดต่อ 180 วัน",
    },
    {
      value: "270",
      label: "เกรด D ขึ้นไป ขาดติดต่อ 270 วัน", 
    },
  ];
export default dataSelectDay;